export const PRINCIPAL = 'principal'
export const PUNCHING = 'punching'
